const SchemaMarkup = () => {
  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "جنّة",
    url: "https://jannah-foods.com",
    description: "جنّة تقدم لك أجود المنتجات الغذائية الأساسية بالجملة من دقيق وسكر وأرز وتوابل بأعلى جودة وأفضل الأسعار",
    sameAs: [],
    contactPoint: {
      "@type": "ContactPoint",
      contactType: "customer service",
      availableLanguage: "Arabic",
    },
  };

  const webSiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "جنّة",
    url: "https://jannah-foods.com",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://jannah-foods.com/products?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webSiteSchema) }}
      />
    </>
  );
};

export default SchemaMarkup;
